var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 3.66664C1.75073 3.66664 1.29854 3.47934 0.965147 3.14594C0.63175 2.81254 0.444448 2.36036 0.444448 1.88886C0.444448 1.41737 0.63175 0.965182 0.965147 0.631783C1.29854 0.298385 1.75073 0.111084 2.22222 0.111084C2.69372 0.111084 3.1459 0.298385 3.4793 0.631783C3.8127 0.965182 4 1.41737 4 1.88886C4 2.36036 3.8127 2.81254 3.4793 3.14594C3.1459 3.47934 2.69372 3.66664 2.22222 3.66664ZM2.22222 9.88887C1.75073 9.88887 1.29854 9.70157 0.965147 9.36817C0.631749 9.03477 0.444448 8.58259 0.444448 8.11109C0.444448 7.63959 0.631749 7.18741 0.965147 6.85401C1.29854 6.52061 1.75073 6.33331 2.22222 6.33331C2.69372 6.33331 3.1459 6.52061 3.4793 6.85401C3.8127 7.18741 4 7.63959 4 8.11109C4 8.58259 3.8127 9.03477 3.4793 9.36817C3.1459 9.70157 2.69372 9.88887 2.22222 9.88887ZM2.22222 16.1111C1.75073 16.1111 1.29854 15.9238 0.965147 15.5904C0.631749 15.257 0.444448 14.8048 0.444448 14.3333C0.444448 13.8618 0.631749 13.4096 0.965147 13.0762C1.29854 12.7428 1.75073 12.5555 2.22222 12.5555C2.69372 12.5555 3.1459 12.7428 3.4793 13.0762C3.8127 13.4096 4 13.8618 4 14.3333C4 14.8048 3.8127 15.257 3.4793 15.5904C3.1459 15.9238 2.69372 16.1111 2.22222 16.1111Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDots);
export default __webpack_public_path__ + "static/media/mobileDots.f8912554ae1d52efaf38c2ddfd3bb724.svg";
export { ForwardRef as ReactComponent };